import { useState } from "react";
import { AssetKey, AssetVariantDTO } from "../../dto/AssetDTO";
import { ReactComponent as FileIcon } from "../file_explorer/assets/file.svg";

interface VariantRowIconProps {
  variant: AssetVariantDTO;
  assetKey: AssetKey;
}

/**
 * Row-sized preview for one localization. Same treatment as the file
 * explorer's rows — thumbnail when the asset is an image, otherwise the
 * type-tinted glyph — so a localization reads as the same kind of thing as
 * the file it belongs to.
 */
export default function VariantRowIcon(props: VariantRowIconProps) {
  const { variant, assetKey } = props;
  const [failed, setFailed] = useState(false);

  if (assetKey === AssetKey.Image && variant.downloadUri && !failed) {
    return (
      <img
        src={variant.downloadUri}
        alt=""
        loading="lazy"
        className="w-full h-full object-cover rounded-[5px]"
        onError={() => setFailed(true)}
      />
    );
  }

  const tintClass =
    assetKey === AssetKey.Pdf
      ? "assetcard-pdf"
      : assetKey === AssetKey.Video
        ? "assetcard-video"
        : assetKey === AssetKey.Audio
          ? "assetcard-audio"
          : "assetcard-loading-icon";

  return <FileIcon className={tintClass + " w-[18px] h-[18px]"} />;
}
